/**
 * Created by filatov on 17.09.2015.
 */
import CostCSVPreviewBaseColumnsStrategy from './CostCSVPreviewBaseColumnsStrategy'

export default function CostCSVPreviewTwoLevelsColumnsStrategy() {}

CostCSVPreviewTwoLevelsColumnsStrategy.prototype = new CostCSVPreviewBaseColumnsStrategy();

CostCSVPreviewTwoLevelsColumnsStrategy.prototype.init = function({showSpentTime, showAverageRates, showOthers}) {
    CostCSVPreviewBaseColumnsStrategy.prototype.init.call(this, showSpentTime, showAverageRates)
    this.showOthers = showOthers
    return this
}

CostCSVPreviewTwoLevelsColumnsStrategy.prototype.getCountGroupingRows = function ()
{
    return 2;
};

CostCSVPreviewTwoLevelsColumnsStrategy.prototype._getNumOfDetailsSubColumns = function () {
    let countText = 1
    if (this.showSpentTime) countText++
    if (this.isShowRatesForTopLevel()) countText++
    return countText
}

CostCSVPreviewTwoLevelsColumnsStrategy.prototype.getNumOfDetailsColumns = function ()
{
    let countText = this._getNumOfDetailsSubColumns()
    if (this.showOthers) countText *= 2
    return countText
};

CostCSVPreviewTwoLevelsColumnsStrategy.prototype.addSecondHeaderRowDataCells = function(row) {
    ReportPreviewUtils.addEmptyCells(row, this.getOverallColumnsCount())
    const countColumns = this._getNumOfDetailsSubColumns()
    for (let i = 0; i < countColumns; i++) {
        this.addCell(row, this.message(this.getLevelNameKey()))
    }
    if (this.showOthers) {
        for (let i = 0; i < countColumns; i++) {
            this.addCell(row, this.message("report.common.others"))
        }
    }
}

CostCSVPreviewTwoLevelsColumnsStrategy.prototype._addFirstHeaderRowDataCells = function(row) {
    if (this.showSpentTime) this.addCell(row, this.message("report.cost.spent"))
    if (this.isShowRatesForTopLevel()) this.addCell(row, this.message("report.cost.rate"))
    this.addCell(row, this.message("report.cost.cost"))
}

CostCSVPreviewTwoLevelsColumnsStrategy.prototype.addFirstHeaderRowDataCells = function(row) {
    this.addOverallHeaderCells(row)
    this._addFirstHeaderRowDataCells(row)
    if (this.showOthers) this._addFirstHeaderRowDataCells(row)
}



// WEBPACK FOOTER //
// ./web/js/reports/preview/csv/cost/CostCSVPreviewTwoLevelsColumnsStrategy.js